export default "__VITE_ASSET__C20dGnEh__"